import React from "react";
import { dowloadFile, getImageUrl } from "../utils/function-utils";
import { Coupon } from "../models/coupon";

export const useCoupon = () => {
    const [ coupon, setCoupon ] = React.useState<Coupon[]>();
    const [ loading, setLoading ] = React.useState<boolean>(true);

    React.useEffect(() => {
        setLoading(true);
        const LOADING_SHOW_TIME_OUT = 1000;
        setCouponData();
        const timer = setTimeout(() => {
            setLoading(false);
        }, LOADING_SHOW_TIME_OUT);

        return () => {
            clearTimeout(timer);
        };
    },[])

    const setCouponData = async (): Promise<void> => {
        try {
            let couponList: Coupon[] = [];
            const couponSession = window.sessionStorage.getItem("couponListData");

            if (couponSession) {
                couponList = JSON.parse(couponSession);
            } else {
                couponList = await dowloadFile("config_coupon/coupon_setup.json");
            }

            const couponDataIsNotExist = !couponList;
            const couponLengthZero = couponList.length === 0;
            if (couponDataIsNotExist || couponLengthZero) { 
                return;
            };

            const counponImage = window.sessionStorage.getItem("couponImage");
            let couponImageMap: Record<string, string> = {};

            if (counponImage) {
                try {
                  couponImageMap = JSON.parse(counponImage);
                } catch (e) {
                  console.error("Invalid couponImage in sessionStorage");
                  return;
                }
            }
            
            for( let i = 0; i < couponList.length; i++ ) {
                const coupon = couponList[i];
                const path = coupon.couponImage;
                const imageIsNotExist = path === "" || !path;
                if (imageIsNotExist) continue;

                const existingPath = couponImageMap[`image_${coupon.couponCode}`]
                if (existingPath) {
                    coupon.couponImage = existingPath
                }else {
                    const mainPathImageOfCoupon = await getImageUrl(path);
                    couponImageMap[`image_${coupon.couponCode}`] = mainPathImageOfCoupon;
                    coupon.couponImage = mainPathImageOfCoupon;
                }

            }

            window.sessionStorage.setItem("couponImage", JSON.stringify(couponImageMap));

            setCoupon(couponList);
            window.sessionStorage.setItem("couponListData", JSON.stringify(couponList));
        } catch (error) {    
            console.log(error)
            return;
        }
    }

    return { coupons: coupon, loading };
}